import { CheckCircle2, Clock, Hourglass, XCircle, AlertTriangle, Ban } from "lucide-react";

/** Tilstand for en Vipps-betaling (vipps_payments.state) → norsk etikett + status-klasse (index.css). */
export const VIPPS_STATES = {
  CREATED: { label: "Startet", cls: "status-ma_kontrolleres", icon: Clock, open: true },
  AUTHORIZED: { label: "Reservert – hentes inn", cls: "status-forfaller_snart", icon: Hourglass, open: true },
  CAPTURED: { label: "Betalt", cls: "status-betalt", icon: CheckCircle2, open: false },
  CANCELLED: { label: "Avbrutt", cls: "status-avvist", icon: Ban, open: false },
  ABORTED: { label: "Avbrutt av kunden", cls: "status-avvist", icon: Ban, open: false },
  EXPIRED: { label: "Utløpt", cls: "status-avvist", icon: XCircle, open: false },
  TERMINATED: { label: "Avsluttet", cls: "status-avvist", icon: XCircle, open: false },
  FAILED: { label: "Feilet", cls: "status-forfalt", icon: AlertTriangle, open: false },
};

export const vippsState = (state) => VIPPS_STATES[state] || { label: state || "Ukjent", cls: "status-avvist", icon: Clock, open: false };

export const VIPPS_ENVIRONMENTS = [
  { value: "test", label: "Test (MT – Merchant Test)" },
  { value: "prod", label: "Produksjon" },
];

export const VIPPS_METHOD_LABELS = { WALLET: "Vipps", CARD: "Kort" };
